import Big from 'big.js';

export const SLIPPAGE_LIMIT = 0.05;

export function computeOrderbookMidPrice({ buys, sells }) {
  if (buys.length === 0 || sells.length === 0) {
    return null;
  }

  const bestBid = Big(buys[0].price);
  const bestOffer = Big(sells[sells.length - 1].price);

  return bestBid.plus(bestOffer).div(Big(2));
}

function computeEffectiveTradePrice(orderBookOrders, orderQuantity) {
  let filledQuantity = Big(0);
  let total = Big(0);

  for (let i = 0; i < orderBookOrders.length && filledQuantity.lt(orderQuantity); i++) {
    const order = orderBookOrders[i];

    const unfilled = orderQuantity.minus(filledQuantity).toFixed();
    const matchQuantity = Big(Math.min(unfilled, order.quantity));

    filledQuantity = filledQuantity.plus(matchQuantity);
    total = total.plus(Big(order.price).times(matchQuantity));
  }

  const effectiveTradePrice = total.div(filledQuantity);
  return { effectiveTradePrice, filledQuantity };
}

export function computeSlippage(orderBookOrders, orderQuantity, orderBookMidPrice) {
  const { effectiveTradePrice, filledQuantity } = computeEffectiveTradePrice(orderBookOrders, orderQuantity);
  if (filledQuantity.lt(orderQuantity)) {
    return { slippage: null, slippageExceeded: true };
  }

  const slippage = effectiveTradePrice.div(orderBookMidPrice).minus(Big(1));
  const slippageExceeded = slippage.gt(SLIPPAGE_LIMIT);
  return {
    slippage,
    slippageExceeded
  };
}
